// Âm thanh "ting" trong trẻo cho thông báo cảnh báo xuất trùng.
// Dùng chung một AudioContext để không tạo quá nhiều context (trình duyệt giới
// hạn ~6 cái).
let sharedCtx: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  try {
    if (!sharedCtx || sharedCtx.state === "closed") {
      const AudioCtx =
        window.AudioContext ||
        (window as unknown as { webkitAudioContext: typeof AudioContext })
          .webkitAudioContext;
      sharedCtx = new AudioCtx();
    }
    return sharedCtx;
  } catch {
    return null;
  }
}

// "Mở khóa" âm thanh: trình duyệt chỉ cho phát âm thanh sau khi người dùng đã
// tương tác. Ta gọi resume() NGAY TRONG gesture. Quan trọng: gắn listener BỀN
// (không dùng { once: true }) và chỉ gỡ khi context đã thực sự "running" — vì
// lần chạm đầu tiên đôi khi chưa được trình duyệt coi là hợp lệ, nếu gỡ luôn thì
// sẽ không bao giờ có tiếng nữa.
export function unlockNotificationAudio() {
  try {
    const ctx = getAudioContext();
    if (ctx && ctx.state === "suspended") {
      void ctx.resume();
    }
  } catch {
    // ignore
  }
}

if (typeof window !== "undefined") {
  const unlockEvents = ["pointerdown", "touchstart", "click", "keydown"];
  const handleUnlock = () => {
    const ctx = getAudioContext();
    if (!ctx) return;
    if (ctx.state === "suspended") {
      void ctx.resume();
    }
    if (ctx.state === "running") {
      unlockEvents.forEach((e) =>
        window.removeEventListener(e, handleUnlock)
      );
    }
  };
  unlockEvents.forEach((e) =>
    window.addEventListener(e, handleUnlock, { passive: true })
  );
  // Quay lại tab cũng là dịp tốt để resume nếu context lỡ bị treo.
  window.addEventListener("focus", handleUnlock);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") handleUnlock();
  });
}

// Một nốt đơn: nổi nhanh rồi tắt dần để tránh tiếng "cạch" ở đầu/cuối.
function tone(
  ctx: AudioContext,
  freq: number,
  startTime: number,
  duration: number,
  peakGain: number
) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.type = "sine";
  osc.frequency.value = freq;

  gain.gain.setValueAtTime(0.0001, startTime);
  gain.gain.exponentialRampToValueAtTime(peakGain, startTime + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);

  osc.start(startTime);
  osc.stop(startTime + duration + 0.02);
}

// "Ting" hai nốt cao đi lên (G6 -> C7) — nghe chú ý nhưng dễ chịu, khác hẳn
// tiếng bíp quét mã nên nhân viên/admin phân biệt được ngay.
export function playNotificationTing() {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    const fire = () => {
      const now = ctx.currentTime;
      tone(ctx, 1568, now, 0.18, 0.35);
      tone(ctx, 2093, now + 0.09, 0.36, 0.28);
    };
    if (ctx.state === "suspended") {
      ctx
        .resume()
        .then(fire)
        .catch(() => {});
    } else {
      fire();
    }
  } catch {
    // ignore audio errors
  }
}